import { render, staticRenderFns } from "./TableActiveFilters.vue?vue&type=template&id=57ce01ba&scoped=true&"
import script from "./TableActiveFilters.vue?vue&type=script&lang=js&"
export * from "./TableActiveFilters.vue?vue&type=script&lang=js&"
import style0 from "./TableActiveFilters.vue?vue&type=style&index=0&id=57ce01ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ce01ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VChipGroup,VIcon})
